import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';
import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';

interface RoundedLoadingButtonProps extends LoadingButtonProps {
    target?: string;
    rel?: string;
}

const ThemeButton = styled(LoadingButton)<RoundedLoadingButtonProps>(({ theme }) => ({
    borderRadius: 30,
    boxShadow: 'none',
}));

export const RoundedLoadingButton = (props: RoundedLoadingButtonProps) => {
    return <ThemeButton {...props} />;
};
